import { LoadingStatus } from '@/types/projects.types';
import { ProjectsDisplayView, ProjectsState, ProjectTimeTypes } from './types';
import { ProjectListSortType } from '@/connection/projects/get-projects';

export const initialState: ProjectsState = {
  projects: [],
  projectsListForSeries: [],
  projectsError: false,
  projectsLoading: false,
  getProjectsOptions: {
    pageSize: 9,
    sort: ProjectListSortType.dateDesc,
    searchCriteria: '',
    time: ProjectTimeTypes.All,
    offset: 0,
  },
  getProjectsListForSeriesOptions: {
    pageSize: 15,
    sort: ProjectListSortType.dateDesc,
    searchCriteria: '',
    time: ProjectTimeTypes.All,
    offset: 0,
  },
  projectToDelete: null,
  projectToEdit: null,
  projectsDisplayView: ProjectsDisplayView.Grid,
  projectsList: [],
  projectsListError: false,
  projectsListLoading: false,
  projectsTotals: null,
  projectGroups: null,
  addProjectsToGroup: [],
  groupError: '',
  groupToDelete: null,
  groupToEdit: null,
  showCreateGroupModal: false,
  loadingProjectGroupsStatus: LoadingStatus.PreLoading,
  selectedProjectGroup: '',
  projectGroupTree: null,
  projectGroupTreeNameMap: null,
  gettingGroupTree: false,
};
